export const WHATSAPP_NUMBER = "351911980230";
export const WHATSAPP_DISPLAY = "+351 911 980 230";

export const translations = {
  pt: {
    nav: {
      about: "Sobre",
      services: "Serviços",
      testimonials: "Testemunhos",
      experience: "Experiência",
      contact: "Contacto",
      cta: "Falar no WhatsApp",
    },
    hero: {
      eyebrow: "Cuidadora Materno Infantil · Lisboa",
      line1: "Cuidar com amor",
      line2: "é construir",
      line3: "futuros.",
      sub: "Acompanhamento noturno especializado para recém-nascidos e apoio à família, com mais de 40 anos de dedicação ao cuidado materno infantil.",
      ctaPrimary: "Agende uma visita",
      ctaSecondary: "Conhecer a Denise",
      badge1: "40+ anos de experiência",
      badge2: "Referências de famílias portuguesas",
    },
    marquee: "Denise Maria · Cuidadora Materno Infantil · Especialista no Sono do Recém-nascido · Apoio ao Aleitamento · Lisboa ·",
    stats: {
      title: "Confiança construída ao longo de décadas",
      sub: "Inúmeras famílias acompanhadas com carinho, presença e experiência real.",
      items: [
        { value: "40+", label: "Anos de experiência" },
        { value: "5", label: "Anos a viver em Lisboa" },
        { value: "∞", label: "Famílias acompanhadas" },
        { value: "24/7", label: "Presença nas noites difíceis" },
      ],
    },
    services: {
      eyebrow: "O que faço por si",
      title: "Um cuidado pensado para cada momento",
      list: [
        {
          n: "01",
          title: "Especialista no sono do recém-nascido",
          desc: "Técnicas suaves e eficazes para noites tranquilas e mais qualidade de vida para toda a família.",
        },
        {
          n: "02",
          title: "Apoio ao aleitamento materno",
          desc: "Orientação, incentivo e acolhimento para uma amamentação segura e confiante.",
        },
        {
          n: "03",
          title: "Suporte em momentos críticos",
          desc: "Experiência e preparo para lidar com fases desafiadoras, como pós-vacina, cólicas, dentição, entre outras.",
        },
        {
          n: "04",
          title: "Experiência internacional e referências sólidas",
          desc: "Vive há 5 anos em Lisboa com excelentes referências de muitas famílias portuguesas.",
        },
      ],
    },
    about: {
      eyebrow: "Sobre mim",
      name: "Denise Maria",
      role: "Cuidadora Especializada · Materno Infantil",
      p1: "Ao longo de mais de quatro décadas, dediquei a minha vida a cuidar dos primeiros dias, semanas e meses de vida de recém-nascidos — e a apoiar as famílias nesse momento tão especial e delicado.",
      p2: "Há 5 anos em Lisboa, construí relações de confiança com muitas famílias portuguesas, que hoje são as minhas melhores referências. Cuidado, dedicação e confiança é o que o seu bebé merece.",
      signature: "Denise Maria",
      quote: "Cuidado, dedicação e confiança que o seu bebé merece.",
    },
    testimonials: {
      eyebrow: "Famílias que confiam",
      title: "Histórias de famílias portuguesas",
      sub: "O carinho e a confiança construídos ao longo de décadas, nas palavras de quem viveu de perto o cuidado da Denise.",
    },
    contact: {
      eyebrow: "Vamos conversar",
      title: "Entre em contacto e agende uma visita",
      sub: "Preencha o formulário ou fale diretamente comigo pelo WhatsApp. Respondo com todo o carinho.",
      name: "Nome",
      email: "Email",
      phone: "Telefone",
      message: "Mensagem",
      messagePlaceholder: "Conte-me um pouco sobre a sua família e o que procura...",
      send: "Enviar pedido",
      sending: "A enviar...",
      or: "ou",
      whatsapp: "Falar no WhatsApp",
      success: "Pedido enviado com sucesso! Entrarei em contacto em breve.",
      error: "Ocorreu um erro. Por favor tente novamente ou use o WhatsApp.",
      wpMessage: "Olá Denise! Gostaria de agendar uma visita para conhecer os seus serviços de cuidadora materno infantil.",
    },
    footer: {
      tagline: "Cuidar com amor é construir futuros.",
      location: "Lisboa e Grande Lisboa, Portugal",
      rights: "Todos os direitos reservados.",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      testimonials: "Testimonials",
      experience: "Experience",
      contact: "Contact",
      cta: "Chat on WhatsApp",
    },
    hero: {
      eyebrow: "Maternal & Infant Caregiver · Lisbon",
      line1: "To care with love",
      line2: "is to build",
      line3: "futures.",
      sub: "Specialised overnight care for newborns and support for families, with over 40 years devoted to maternal and infant care.",
      ctaPrimary: "Book a visit",
      ctaSecondary: "Meet Denise",
      badge1: "40+ years of experience",
      badge2: "References from Portuguese families",
    },
    marquee: "Denise Maria · Maternal & Infant Caregiver · Newborn Sleep Specialist · Breastfeeding Support · Lisbon ·",
    stats: {
      title: "Trust built over decades",
      sub: "Countless families cared for with warmth, presence and real experience.",
      items: [
        { value: "40+", label: "Years of experience" },
        { value: "5", label: "Years living in Lisbon" },
        { value: "∞", label: "Families cared for" },
        { value: "24/7", label: "Presence on the hard nights" },
      ],
    },
    services: {
      eyebrow: "What I do for you",
      title: "Care designed for every moment",
      list: [
        {
          n: "01",
          title: "Newborn sleep education specialist",
          desc: "Gentle, effective techniques for peaceful nights and better quality of life for the whole family.",
        },
        {
          n: "02",
          title: "Breastfeeding support",
          desc: "Guidance, encouragement and warmth for safe and confident breastfeeding.",
        },
        {
          n: "03",
          title: "Support through critical moments",
          desc: "Experience and readiness to handle challenging phases — post-vaccine, colic, teething and more.",
        },
        {
          n: "04",
          title: "International experience & solid references",
          desc: "Living in Lisbon for 5 years with excellent references from many Portuguese families.",
        },
      ],
    },
    about: {
      eyebrow: "About me",
      name: "Denise Maria",
      role: "Specialised Caregiver · Maternal & Infant",
      p1: "For more than four decades I have devoted my life to caring for the first days, weeks and months of newborns — and to supporting families through such a special and delicate time.",
      p2: "For 5 years in Lisbon, I have built relationships of trust with many Portuguese families who are now my best references. Care, dedication and trust is what your baby deserves.",
      signature: "Denise Maria",
      quote: "Care, dedication and trust that your baby deserves.",
    },
    testimonials: {
      eyebrow: "Families who trust",
      title: "Stories from Portuguese families",
      sub: "The warmth and trust built over decades, in the words of those who experienced Denise's care first-hand.",
    },
    contact: {
      eyebrow: "Let's talk",
      title: "Get in touch and book a visit",
      sub: "Fill in the form or message me directly on WhatsApp. I answer with all my heart.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      messagePlaceholder: "Tell me a little about your family and what you're looking for...",
      send: "Send request",
      sending: "Sending...",
      or: "or",
      whatsapp: "Chat on WhatsApp",
      success: "Request sent successfully! I'll be in touch soon.",
      error: "Something went wrong. Please try again or use WhatsApp.",
      wpMessage: "Hello Denise! I would like to book a visit to learn more about your maternal & infant care services.",
    },
    footer: {
      tagline: "To care with love is to build futures.",
      location: "Lisbon & Greater Lisbon, Portugal",
      rights: "All rights reserved.",
    },
  },
};
